import { render } from "./SearchLessonByTextContent.vue?vue&type=template&id=2b4b1fea&scoped=true"
import script from "./SearchLessonByTextContent.vue?vue&type=script&lang=js"
export * from "./SearchLessonByTextContent.vue?vue&type=script&lang=js"

import "./SearchLessonByTextContent.vue?vue&type=style&index=0&id=2b4b1fea&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4b1fea"]])

export default __exports__